import { createStore } from "redux";
import reducer from "../reducers";

const store = createStore(reducer);

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js